import { Enums } from "../common/enums"
import { ConvertHelper } from "../../helpers"

import { ICopyable, IOpChangeState } from "../util/interfaces"
import { OpPacketStatus } from "./op-packet-status"

export class OpPacketHistory implements IOpChangeState, ICopyable<OpPacketHistory> {

    //#region Properties

    public idPacketHistory: number
    public idPacket: number
    public time: Date
    public idPacketStatus: number
    public systemTime: Date

    //#endregion


    //#region Navigation properties

    public packetStatus: OpPacketStatus

    //#endregion


    //#region Custom properties

    public opState: Enums.OpChangeState

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    public toString(): string {
        return `PacketHistory [${this.idPacketHistory}]`
    }


    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idPacketHistory = opObj.ID_PACKET_HISTORY
            this.idPacket = opObj.ID_PACKET

            if (opObj.TIME != null) {
                this.time = ConvertHelper.stringToDate(opObj.TIME)
            }

            this.idPacketStatus = opObj.ID_PACKET_STATUS

            if (opObj.SYSTEM_TIME != null) {
                this.systemTime = ConvertHelper.stringToDate(opObj.SYSTEM_TIME)
            }

            if (opObj._PacketStatus != null) {
                this.packetStatus = new OpPacketStatus(opObj._PacketStatus)
            }

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_PACKET_HISTORY: this.idPacketHistory,
            ID_PACKET: this.idPacket,
            TIME: this.time != null ? ConvertHelper.dateToString(this.time, { netFormat: true, includeTimeZone: true }) : undefined,
            ID_PACKET_STATUS: this.idPacketStatus,
            SYSTEM_TIME: this.time != null ? ConvertHelper.dateToString(this.systemTime, { netFormat: true, includeTimeZone: true }) : undefined,
            _PacketStatus: this.packetStatus != null ? this.packetStatus.toJSON() : null,

            OpState: this.opState
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPacketHistory {
        const newPacket: OpPacketHistory = new OpPacketHistory(null)

        newPacket.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newPacket
    }

    public copy(source: OpPacketHistory, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.packetStatus != null) {
                const status: OpPacketStatus = new OpPacketStatus(null)
                status.copy(source.packetStatus, true, true, true, true)
                this.packetStatus = status
            }

        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            //no dataList
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idPacketHistory = source.idPacketHistory
        this.idPacket = source.idPacket
        this.time = source.time
        this.idPacketStatus = source.idPacketStatus
        this.systemTime = source.systemTime

        this.opState = source.opState
    }

    //#endregion

}